import * as selectors from "./selectors";
import * as events from "./events";

export const AUTH_STORE_INSTANCE = {
  selectors,
  events,
};
